import { render, staticRenderFns } from "./trackPatient.vue?vue&type=template&id=c2e01856&scoped=true&"
import script from "./trackPatient.vue?vue&type=script&lang=js&"
export * from "./trackPatient.vue?vue&type=script&lang=js&"
import style0 from "./trackPatient.vue?vue&type=style&index=0&id=c2e01856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e01856",
  null
  
)

export default component.exports